import { useAtom, useAtomValue } from 'jotai';
import MaterialWiki from '../../components/wiki/material-wiki-base';

import { Box, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import MainToolbarMaterial from '../../components/wiki/wiki-toolbar';
import { baseAtom, checkRole } from '../../stores/jotai/base';
import PresentationLinks from '../presentation-links';
import { useGetWikies } from '../../tanstackQuery/queries/wiki';
import { discoverySessionAtom } from '../../stores/jotai/discovery-session';
import { useKeycloak } from '@react-keycloak/web';

// const exampleJSON = require('./wiki-example-data.json')
// export const cohortSections = exampleJSON.sections

// export const cohortSectionsAtom = atom(cohortSections)

function flattenSections(sections) {
    return sections;
}

export default function InfoHubView() {
    const [base, setBase] = useAtom(baseAtom);
    const location = useLocation();
    const discoverySession = useAtomValue(discoverySessionAtom);
    const { keycloak, } = useKeycloak();
    const { data: wikies,isLoading:isWikiLoading } = useGetWikies(
      { accessToken: keycloak?.token },
      {
        groupID: base?.team?.groupID,
        sessionID: discoverySession?.sessionID,
        cohortID: base?.cohort?.id,
        orgID: base?.team?.orgID
      },
      {
        enabled: !!(
          base?.team?.groupID &&
          discoverySession?.sessionID &&
          base?.cohort?.id &&
          base?.team?.orgID
        )
      }
    );

    const currentPath = location.pathname + location.search;
    const theme = useTheme();
    let memoizedWiki = useMemo(() => {
        
        let hasEditPermission = false;

        let videoMode = false;
        let wiki = undefined;

        let sections = [];

        if (currentPath === "/information-hub?t=0" || currentPath === "/information-hub") {
            hasEditPermission = checkRole(base, "isCohortAdmin");

            // cohort info hub
            for (let i = 0; i < wikies?.wikis?.length; i++) {
                if (wikies?.wikis[i]?.name === "Information Hub" && wikies?.wikis[i].groupID == base?.cohort?.groupID) {
                    sections = flattenSections(wikies?.wikis[i]?.sections);
                    //console.log(sections);
                    wiki = wikies?.wikis[i];
                }
            }
        }
        else if (currentPath === "/information-hub?t=1") {
            hasEditPermission =
                checkRole(base, "isCohortAdmin") ||
                checkRole(base, "isTeamMember");

            // team info hub
            for (let i = 0; i < wikies?.wikis?.length; i++) {
                if (wikies?.wikis[i]?.name === "Team Information Hub" && wikies?.wikis[i]?.groupID == base?.team?.groupID) {
                    sections = flattenSections(wikies?.wikis[i].sections);
                    //console.log(sections);
                    wiki = wikies?.wikis[i];
                }
            }
        }
        else if (currentPath === "/course-videos") {
            hasEditPermission = checkRole(base, "isCohortAdmin");
            videoMode = true;

            for (let i = 0; i < wikies?.wikis?.length; i++) {
                if (wikies?.wikis[i]?.name === "Course Videos") {
                    sections = flattenSections(wikies?.wikis[i]?.sections);
                    wiki = wikies?.wikis[i];
                }
            }
        }

        return (
            <Box sx={{
                height: "100%",
            }}>
                <MainToolbarMaterial hasEditPermission={hasEditPermission} videoMode={videoMode}/>
                <MaterialWiki
                    videoLibrary={videoMode}
                    wiki={wiki}
                    key={`material-wiki-info-hub-${currentPath}`}
                    sectionsAtom={sections}
                    editable={hasEditPermission}
                    wikies={wikies}
                />
            </Box>
        );
    }, [wikies, location]);

    if (currentPath === "/presentation-links"  || currentPath === "/information-hub?t=2") {
        return <div style={{ backgroundColor: theme?.custom?.mainBackgroundColor, flex: '1', height: '100%' }}>
            <Box>
                <MainToolbarMaterial />
                <PresentationLinks />
            </Box>
        </div>
    }

    return <div style={{ backgroundColor: theme?.custom?.mainBackgroundColor, flex: '1', height: '100%' }}>
        {isWikiLoading ? <LinearProgress /> : memoizedWiki}
    </div>
}
